import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../HardwareDetails/HardwareDetails";
import { ActionsModal } from "../ActionsModal";
import { generateReturnAssetTicket } from "../../../helper/generateTicket";
import { ActionStatusContext } from "../Actions";
import { createZendeskTicket } from "../../../resource/bff";

export default function ReturnModal(props) {
  const userDetails = useContext(UserDetailsContext);
  const { setIsLoading, showActionResponse, setIsActionSuccess } =
    useContext(ActionStatusContext);
  const [serialNumber, setSerialNumber] = useState("");
  const [reason, setReason] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    props.onClose();
    setIsLoading(true);
    const assetName = props.assets.find(
      (asset) => asset.serialNumber == serialNumber
    ).modelName;
    const ticket = generateReturnAssetTicket(
      userDetails.workingOffice.country,
      userDetails.homeOffice.name,
      userDetails.homeOffice.country,
      userDetails.employeeNumber,
      assetName,
      serialNumber,
      reason
    );
    try {
      await createZendeskTicket(ticket);
      setIsActionSuccess(true);
    } catch (error: any) {
      setIsActionSuccess(false);
    } finally {
      setSerialNumber("");
      setReason("");
    }
    setIsLoading(false);
    showActionResponse();
  };

  return (
    <ActionsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      heading={"Return"}
      title={"Hardware assigned to me"}
      isFormValid={reason != "" && serialNumber != ""}
      onSubmit={onSubmit}
    >
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"device-dropdown-label"}>
          <Typography display={"inline"}>Select assigned device</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        {props.assets && (
          <Select
            labelId={"device-dropdown-label"}
            onChange={(e: SelectChangeEvent) => {
              setSerialNumber(e.target.value);
            }}
            value={serialNumber}
            sx={{
              width: "400px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {props.assets.map((row) => (
              <MenuItem key={row.serialNumber} value={row.serialNumber}>
                <span
                  style={{
                    width: "368px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >{`${row.modelName} - ${row.serialNumber}`}</span>
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "32px" }}
      >
        <InputLabel id={"reason-label"}>
          <Typography display={"inline"}>Please specify the reason</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
          }}
          aria-labelledby={"reason-label"}
        />
      </FormControl>
    </ActionsModal>
  );
}
